export { rippleModalHeaderIcon } from './rippleModalHeaderIcon';
